var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80.091,
    viewBox: "0 0 80 80.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-plus",
    d: "M42.9,2.973a6.667,6.667,0,0,0-6.569,6.758V36.4H9.667a6.667,6.667,0,1,0,0,13.334H36.333V76.4a6.667,6.667,0,1,0,13.334,0V49.73H76.333a6.667,6.667,0,1,0,0-13.334H49.666V9.731A6.667,6.667,0,0,0,42.9,2.973Z",
    transform: "translate(-3 -2.972)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.bea8e258e9100d4d5358b32ec28dee95.svg";
export { ForwardRef as ReactComponent };